export default "__VITE_ASSET__Dh4gdy$t__"